
// src/components/BackButton.jsx

import { useNavigate } from 'react-router-dom';

export default function BackButton({ label = "Back" }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      className="absolute top-6 right-6 flex items-center gap-2 px-4 py-2 bg-white text-gray-700 font-medium text-sm uppercase tracking-wide border border-gray-300 rounded-full shadow-sm hover:bg-gray-50 hover:shadow hover:text-gray-900 transition-all duration-200 group"
      aria-label="Go back"
    >
      {/* Arrow Icon with Animation */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4 group-hover:-translate-x-1 transition-transform duration-150"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
      </svg>
      {label}
    </button>
  );
}